// index.ts
import { CRUDL, installExtension } from "@juitnow/lib-fetch-client";
export * from "../types/validators.mjs";
var CartsImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/orders/v2/carts");
  }
  create(cart) {
    return this._crudl.create(cart);
  }
  delete(uuid) {
    return this._crudl.delete(uuid);
  }
  list() {
    return this._crudl.list();
  }
  async put(uuid, cart) {
    const response = await this._crudl.http.put(`/orders/v2/carts/${uuid}`, cart);
    return response.data;
  }
  read(uuid) {
    return this._crudl.read(uuid);
  }
};
installExtension("carts", CartsImpl);
var OrdersImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/orders/v2");
  }
  async create(order) {
    return await this._crudl.create(order);
  }
  async manual(order) {
    const response = await this._crudl.http.post("/orders/v2/manual", order);
    return response.data;
  }
  /** @deprecated: use `client.b2bOrders.create(...)` */
  /* coverage ignore next */
  async createB2B(order) {
    await this._crudl.http.post("/orders/v2/b2b", order);
  }
  async preorder(preorder) {
    const response = await this._crudl.http.post("/orders/v2/preorder", preorder);
    return response.data;
  }
  async cancel(uuid) {
    const response = await this._crudl.http.post(`/orders/v2/${uuid}/cancel`);
    return response.data;
  }
  async read(uuid, opts) {
    return await this._crudl.read(uuid, opts);
  }
  async list(query) {
    const status = query.status?.join(",");
    return await this._crudl.list({ ...query, tag: query.tag?.join(","), status });
  }
  async patch(uuid, updates) {
    return this._crudl.update(uuid, updates);
  }
  async sendConfirmationEmail(uuid, params) {
    await this._crudl.http.post(`/orders/v2/${uuid}/send-confirmation-email`, params);
  }
  async invoices(uuid) {
    const response = await this._crudl.http.get(`/orders/v2/${uuid}/invoices`);
    return response.data;
  }
  async refund(uuid, params) {
    const response = await this._crudl.http.post(`orders/v2/${uuid}/refund`, params);
    return response.data;
  }
};
installExtension("ordersV2", OrdersImpl);
var B2BOrdersImpl = class {
  _crudl;
  constructor(http) {
    this._crudl = new CRUDL(http, "/orders/v2/b2b");
  }
  async create(order) {
    return await this._crudl.create(order);
  }
  async read(uuid) {
    return await this._crudl.read(uuid);
  }
  async delete(uuid) {
    await this._crudl.delete(uuid);
  }
  async list(query) {
    return await this._crudl.list(query);
  }
  async update(uuid, data) {
    const response = await this._crudl.http.put(`orders/v2/b2b/${uuid}`, data, { acceptStatuses: [404] });
    if (response.status === 404) return void 0;
    return response.data;
  }
  async confirm(uuid) {
    const response = await this._crudl.http.post(`orders/v2/b2b/${uuid}/confirm`, {}, { acceptStatuses: [404] });
    if (response.status === 404) return void 0;
    return response.data;
  }
};
installExtension("b2bOrders", B2BOrdersImpl);
export {
  B2BOrdersImpl,
  CartsImpl,
  OrdersImpl
};
//# sourceMappingURL=index.mjs.map
